import React from "react";

const ChevronDownAutocomplete: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.29243 7.30468C5.47973 7.11758 5.73374 7.01248 5.99858 7.01248C6.26342 7.01248 6.51743 7.11758 6.70473 7.30468L9.99376 10.5911L13.2828 7.30468C13.3749 7.20936 13.4851 7.13333 13.607 7.08102C13.7288 7.02872 13.8599 7.00119 13.9925 7.00004C14.1251 6.99889 14.2567 7.02414 14.3794 7.07432C14.5022 7.1245 14.6137 7.1986 14.7075 7.2923C14.8012 7.38601 14.8754 7.49744 14.9256 7.62009C14.9758 7.74274 15.0011 7.87415 15 8.00666C14.9988 8.13918 14.9713 8.27013 14.9189 8.39189C14.8666 8.51365 14.7905 8.62377 14.6951 8.71584L10.6999 12.7078C10.5126 12.8949 10.2586 13 9.99376 13C9.72891 13 9.47491 12.8949 9.28761 12.7078L5.29243 8.71584C5.10519 8.52868 5 8.27489 5 8.01026C5 7.74562 5.10519 7.49183 5.29243 7.30468V7.30468Z"
      fill="#222222"
    />
  </svg>
);

export default ChevronDownAutocomplete;
